import type { IsoDate } from '../../domain/dates';
import { APP_DATA_VERSION, parseAppData, readJson, type AppData } from './app-data';

/**
 * DE: Sicherung lässt sich nicht einlesen: kaputt oder von einer neueren App-Version.
 * EN: A backup cannot be restored: broken or from a newer app version.
 */
export class BackupError extends Error {
  constructor(readonly code: 'invalid' | 'newer-version') {
    super(`Backup cannot be restored: ${code}`);
    this.name = 'BackupError';
  }
}

/**
 * DE: Sicherung als lesbares JSON.
 * EN: Backup as readable JSON.
 */
export function exportBackup(data: AppData): string {
  return JSON.stringify(data, null, 2);
}

/**
 * DE: Dateiname der Sicherung mit Datum.
 * EN: File name of the backup with its date.
 */
export function backupFileName(today: IsoDate): string {
  return `plan-to-eating-${today}.json`;
}

/**
 * DE: Sicherung einlesen; Fehler nennen den Grund als Code.
 * EN: Restore a backup; errors name the reason as a code.
 */
export function importBackup(text: string): AppData {
  const value = readJson(text);
  const version = (value as { version?: unknown } | null)?.version;
  if (typeof version === 'number' && version > APP_DATA_VERSION) {
    throw new BackupError('newer-version');
  }
  const data = parseAppData(value);
  if (!data) throw new BackupError('invalid');
  return data;
}
